import * as React from 'react';
import { SVGProps } from 'react';

const SvgStretch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M19.57 36.125c-3.226 0-6.381-.963-9.065-2.769a16.413 16.413 0 0 1-6.012-7.377 16.547 16.547 0 0 1-.93-9.5 16.474 16.474 0 0 1 4.469-8.416 16.285 16.285 0 0 1 8.355-4.497 16.213 16.213 0 0 1 9.427.935 16.346 16.346 0 0 1 7.325 6.052 16.52 16.52 0 0 1 2.752 9.134c0 4.362-1.72 8.543-4.782 11.625a16.262 16.262 0 0 1-11.539 4.813Z"
    />
    <path
      fill={props.fill}
      d="M21.624 19.692v4.887l10.413.024 4.838-4.871-15.251-.04Z"
    />
    <path
      fill="currentColor"
      d="M19.57 12.67a2.09 2.09 0 0 1-1.474-.62 2.119 2.119 0 0 1-.613-1.487v-1.05a2.122 2.122 0 0 1 .575-1.555 2.093 2.093 0 0 1 1.515-.654 2.08 2.08 0 0 1 1.515.654 2.107 2.107 0 0 1 .575 1.555v1.05a2.12 2.12 0 0 1-.614 1.489 2.09 2.09 0 0 1-1.479.618m9.755.909H9.815v1.856s6.736.49 6.736.614l.605 4.91-3.282 10.416 2.253.53 3.166-8.289a.303.303 0 0 1 .471-.158c.052.04.09.095.109.158l3.21 8.29 2.252-.531-3.326-10.43.737-4.641c0-.137 6.584-.884 6.584-.884l-.005-1.841Z"
    />
  </svg>
);

export default SvgStretch;
